const KILOBYTE = 1024;

/** Filstørrelse i dansk notation. Spejler formatAttachmentSize i
 * selvbetjeningen, så medlem og sagsbehandler ser det samme tal. */
export const formatAttachmentSize = (sizeBytes: number): string => {
  if (sizeBytes < KILOBYTE) {
    return `${sizeBytes} B`;
  }

  if (sizeBytes < KILOBYTE * KILOBYTE) {
    return `${Math.round(sizeBytes / KILOBYTE)} KB`;
  }

  return `${(sizeBytes / (KILOBYTE * KILOBYTE)).toFixed(1).replace(".", ",")} MB`;
};
